export default __webpack_public_path__ + "static/media/animalsDancing.4f728757.jpg";